import { Component, Input, OnInit } from '@angular/core';

import { EmpowerModernLifeService } from 'src/services/empower-services/empower-modern-life.service';
import { EmpowerExportService } from 'src/services/empower-services/empower-export.service';
import { generateTitleDiv, NO_IMAGE, undefinedImagePath } from 'src/modules/empower-module/helper';

@Component({
  selector: 'empower-pca-hybrid-work',
  templateUrl: './pca-hybrid-work.component.html',
  styleUrls: ['./pca-hybrid-work.component.scss']
})
export class EmpowerPcaHybridWorkComponent implements OnInit {

  @Input() data: any;

  imageUrl = "../assets/empower/pitch-factory/images/50-screen-01.png";
  innerHtml = '';

  constructor(public empowerModernLifeService: EmpowerModernLifeService, private empowerExportService: EmpowerExportService) { }

  ngOnInit(): void {
    if (this.data) {
      this.data = JSON.parse(this.data);
      this.checkPageState(this.data.pageId);
    }
  }

  checkPageState(pageId) {
    const imageUrl = this.empowerModernLifeService.getPageImgState(pageId);
    if (imageUrl) {
      this.imageUrl = imageUrl;
    }
    if (this.imageUrl == NO_IMAGE) this.emitExportEvent(null);

    this.innerHtml = generateTitleDiv(this.data);
  }

  imageChange(imageUrl) {
    this.empowerModernLifeService.setPageImgState(this.data.pageId, imageUrl);
  }

  emitExportEvent(resolvedState: boolean) {
    setTimeout(() => {
      this.data && this.data.export && this.empowerExportService.setExportComponentSubject(50, resolvedState, this.data.pageIndex, this.data.pageTitle);
    }, 1000);
  }

}
